import { render, staticRenderFns } from "./tableVersion.vue?vue&type=template&id=c389712c&scoped=true"
import script from "./tableVersion.vue?vue&type=script&lang=js"
export * from "./tableVersion.vue?vue&type=script&lang=js"
import style0 from "./tableVersion.vue?vue&type=style&index=0&id=c389712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c389712c",
  null
  
)

export default component.exports